import classNames from 'classnames';
import { useState } from 'react';
import Info from '../../components/common/Info';
import ResultBox from '../../components/common/ResultBox';
import GapAround from '../../components/hoc/GapAround';
import { imageUrl } from '../../utils';
import { useMediaQuery } from '@mui/material';
import SubInfo from '../../components/common/SubInfo';
import StepsBox from '../../components/common/StepsBox';

const StepsWeFollow = () => {
  const isLessThan640 = useMediaQuery('(max-width: 640px)');
  const isLessThan1150 = useMediaQuery('(max-width: 1150px)');
  const isLessThan1280 = useMediaQuery('(max-width: 1280px)');

  const [activeStep, setActiveStep] = useState(0);

  const resultBoxClasses = isLessThan640
    ? 'grid grid-cols-1 gap-1 mdmax:mx-0 mx-3'
    : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 mx-3 md:mx-2';

  return (
    <div className={classNames("smmax:mx-5 mdmax:mx-0 ", isLessThan1150 ? 'mx-10' : '')}>
      <GapAround childrenClasses="space-y-3 md:space-y-5 lgspace-y-10">
        <div className="image_and_info flex items-center justify-around mdmax:space-x-0 space-x-6 mb-6 md:mb-8 lg:mb-16 breaktwo:relative">
          <div className="flex-1 breaktwo:absolute breaktwo:top-24 breaktwo:opacity-30">
            <img loading="lazy" className="max-w-full" src={imageUrl('step_to_cup.svg')} alt="step to cup" />
          </div>
          <div className="flex-1 breaktwo:text-center">
            <Info variant={'h2'}
              typographyStyles={{
                fontSize: isLessThan1280 ? 28 : 42,
              }}>
              {'From diagnosis to better software'}
            </Info>
            <div className="flex-1 breaktwo:text-center mt-[15px]">
              <SubInfo>{'We take a practical, results-driven approach to improving your software. From auditing your codebase to fixing critical issues and optimizing performance, our clinic makes your app healthier, more reliable, and ready to scale.'}</SubInfo>
            </div>
          </div>
        </div>
        <div className="absolute left-0 -top-[6rem] z-[0.9] breaktwo:hidden">
          <img loading='lazy' src={imageUrl('single_flower_right.svg')} alt="single flower right" />
        </div>

        <div className={`${resultBoxClasses} items-stretch relative`} onMouseLeave={() => setActiveStep(0)}>
          {stepBoxData.map((step, index) => (
            <StepsBox
              key={step.heading}
              containerClasses={step.containerClasses}
              heading={step.heading}
              subHeadingStyle={step.subHeadingStyle}
              descriptionStyle={step.descriptionStyle}
              headingStyle={step.headingStyle}
              subheading={step.subheading}
              description={step.description}
              describeImage={step.describeImage}
              highlighted={activeStep === index}
              onMouseEnter={() => setActiveStep(index)}
              noWidth
              alt={step?.alt as any}
            />
          ))}
        </div>
      </GapAround>
    </div>
  );
};

export default StepsWeFollow;

const stepBoxData = [
  {
    containerClasses: "bg-[#F8F8F8]",
    heading: '01',
    subheading: 'Audit',
    description: 'Evaluate what’s working and uncover bugs, risks, and technical debt.',
    describeImage: 'stethoscope.svg',
    headingStyle: {
      fontSize: 48,
      fontWeight: 500,
      lineHeight: 1.25,
      fontFamily: 'ABeeZee',
    },
    subHeadingStyle: { fontSize: 22, fontWeight: 500, marginTop: 4, lineHeight: 1.15, fontFamily: 'ABeeZee' },
    descriptionStyle: { fontSize: 16, lineHeight: 1.25, fontFamily: 'ABeeZee' },
    alt: 'Diagnostics & Audits',
  },
  {
    containerClasses: "bg-[#F8F8F8]",
    heading: '02',
    subheading: 'Treatment',
    description: 'Treat what needs attention. Resolve critical issues and repair what’s broken.',
    describeImage: 'treatment.svg',
    alt: 'Treatment & Recovery',
  },
  {
    containerClasses: "bg-[#F3F1F2]",
    heading: '03',
    subheading: 'Optimize',
    description: 'Improve architecture, performance, UX, and maintainability.',
    describeImage: 'knife.svg',
    alt: 'Surgery & Rebuilds',
  },
  {
    containerClasses: "bg-[#E8E5E7]",
    heading: '04',
    subheading: 'Ongoing Care',
    description: 'Dedicated team who knows your codebase and keeps it running smoothly.',
    describeImage: 'care.svg',
    alt: 'Ongoing Care',
  },
]
